
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/liquidity",
      function () {
        return require("private-next-pages/liquidity/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/liquidity"])
      });
    }
  